export default {
  getHead: () => {
    return [{ name: '학교명' }, { name: '재해일시' }, { name: '성명' }, { name: '직종(재해자)' }, { name: '초진 결과(예상)' }, { name: '재해형태' }, { name: '작성부서' }, { name: '작성일' }]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 회사명
      case 1: return func.getContent(value).inputC_1 // 재해일시
      case 2: return func.onNameBlur(func.getContent(value).inputD_1) // 성명
      case 3: return func.getContent(value).inputC_6 // 직종(재해자)
      case 4: return func.getContent(value).inputE_1 // 초진 결과(예상)
      case 5: return func.getContent(value).inputC_14 // 재해형태
      case 6: return func.getContent(value).stdInfo.com_name // 작성부서
      case 7: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { disasterType: nav.value.disasterType, searchType: nav.value.searchType,  searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    if (nav.value.disasterType) returnData.push('content$body.inputC_14*[:default_disaster]')

    switch (nav.value.searchType) {
    case '학교명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
    case '재해일시': returnData.push('content$body.inputC_1*%[:default_skw]%'); break
    case '성명': returnData.push('content$body.inputD_1*%[:default_skw]%'); break
    case '직종(재해자)': returnData.push('content$body.inputC_6*%[:default_skw]%'); break
    case '초진 결과(예상)': returnData.push('content$body.inputE_1*%[:default_skw]%'); break
    case '작성부서': return ['content$body.stdInfo.com_name*%[:default_skw]%']
    }
    return returnData
  },
}
